/**
 * An unset MTA currency is USD — the backend field's default. Upper-cased because the exposure
 * buckets it is matched against are.
 */
export function resolveMtaCurrency(currency?: string | null): string {
  return (currency || 'USD').toUpperCase();
}

/** An MTA threshold as text, e.g. "50,000 USD". Two decimals at most: a threshold converted at a
 *  COB rate carries more. */
export function formatMta(mta: number, currency?: string | null): string {
  return `${mta.toLocaleString('en-US', { maximumFractionDigits: 2 })} ${resolveMtaCurrency(currency)}`;
}

/** Why a below-MTA badge is shown — the same words on the MTM bar and in History. */
export function belowMtaReason(mta: number, currency?: string | null): string {
  return `Below minimum transfer amount (${formatMta(mta, currency)}) — no transfer`;
}
